import React from 'react';

export function Stepper({ value, onChange, min = 0, max = Infinity, small = false }) {
  const handleMinus = () => {
    const newValue = Math.max(min, (parseInt(value) || 0) - 1);
    onChange(newValue);
  };

  const handlePlus = () => {
    const newValue = Math.min(max, Math.max(min, (parseInt(value) || 0) + 1));
    onChange(newValue);
  };

  const handleInputChange = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, '');
    onChange(val === '' ? '' : parseInt(val) || 0);
  };

  const handleBlur = () => {
    const numVal = parseInt(value) || min;
    const clamped = Math.max(min, Math.min(max, numVal));
    onChange(clamped);
  };

  return (
    <div className={`stepper ${small ? 'small' : ''}`}>
      <button type="button" className="stepper-btn" onClick={handleMinus}>−</button>
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onFocus={(e) => {
          const input = e.target;
          requestAnimationFrame(() => input.setSelectionRange(input.value.length, input.value.length));
        }}
      />
      <button type="button" className="stepper-btn" onClick={handlePlus}>+</button>
    </div>
  );
}
